import EditIcon from '../../../../../assets/icons/icon-pen-blue.svg';
import DeleteIcon from '../../../../../assets/icons/icon-cross-red.svg';
import { EntityNames } from "../../../../../enums/EntityNames"
import SidePanelList from "./SidePanelList"
import { FilterMatchType } from '../../../../../enums/FilterMatchType';
import { PropertyTypes } from '../../../../../enums/PropertyTypes';
import { IFilter } from '../../../../../hooks/UseFilters';
import { usePermissions } from '../../../../../modules/auth/Permissions/PermissionContext';
import { hasPermission } from '../../../../../modules/auth/Permissions/PermissionModule';
import { PermissionConcerns, PermissionTypes } from '../../../../../modules/auth/Permissions/PermissionStrings';

interface ISidePanelPackingBoxCases {
    id: string,
    editCaseFunction: (id: string, entityName?: string) => void,
    caseData: IPackingBoxCase | undefined,
    onAddNewClicked: Function,
    itemsToAdd?: IPackingBoxCase[] | undefined,
    onItemRemoved?: (item: IPackingBoxCase) => void
}

export interface IPackingBoxCase {
    id: string,
    code: string,
    year: number,
    prefix: string,
    entityName?: string,
}

export default function SidePanelPackingBoxCases(props: ISidePanelPackingBoxCases) {

    const { id, onAddNewClicked, editCaseFunction, caseData, itemsToAdd, onItemRemoved } = props;
    const { permissions } = usePermissions();
    
    const canManageCase = hasPermission(permissions!, PermissionTypes.write, PermissionConcerns.Manage_Case);

    return (
        <SidePanelList<IPackingBoxCase>
            id={id}
            entityName={EntityNames.cases}
            url={`api/${EntityNames.cases}/listWithSpecimens`}
            searchLabel={"Enter a case number"}
            onAddNewClicked={onAddNewClicked}
            editFunction={editCaseFunction}
            itemData={caseData}
            itemsToAdd={itemsToAdd}
            onItemRemoved={onItemRemoved}
            canAdd={canManageCase}
            canEdit={canManageCase}
            canDelete={canManageCase}
            itemDisplayName={(item: IPackingBoxCase) => "case / part case"}
            displayName='Cases / part cases'
            loadingRowCount={4}
            searchFilter={(searchVal?: string | undefined) => {
                return {
                    propertyName: "Code",
                    value: searchVal,
                    required: false,
                    matchType: FilterMatchType.Equal,
                    type: PropertyTypes.string
                } as IFilter
            }}
            renderRowContent={(item, edit, remove) => (
                <>
                    <td style={{ minWidth: '200px' }}>
                        <div className="side-panel-table__cell-content">
                            <p className="small small--2">{item.code}</p>
                        </div>
                    </td>
                    <td>
                        <div className="side-panel-table__cell-content">
                            <p className="small small--2">{item.year}</p>
                        </div>
                    </td>
                    <td>
                        <div className="display--flex gap--m justifyContent--flex-end">
                            {edit &&
                                <div className="cursor__pointer side-panel-table__cell-content display--flex justifyContent--flex-end" onClick={() => edit(item.id, item.entityName)}>
                                    <img className="small-1" src={EditIcon} />
                                </div>
                            }
                            {remove &&
                                <div className="cursor__pointer side-panel-table__cell-content display--flex justifyContent--flex-end" onClick={() => remove(item)}>
                                    <img className="small-1" src={DeleteIcon} />
                                </div>
                            }
                        </div>
                    </td>
                </>
            )}
            displayColumns={
                <>
                    <th style={{ minWidth: '200px' }}><p className="small">Case Number</p></th>
                    <th><p className="small">Year</p></th>
                    <th><p className="small"></p></th>
                </>
            }
        />
    );
}